<template>
  <div class="introduction">
    <div class="header">
      <img src="../../../../../assets/img/logo/bonyad_logo/bonyad.png" alt="Logo" class="logo" />
    </div>
    <div class="title">
      <h1>گزارش بررسی عملکرد اقتصادی</h1>
      <h2>هلدینگ گسترش صنایع معدنی کاوه پارس</h2>
    </div>
    <div class="subtitle">
      <h3>۶ ماهه سال ۱۴۰۳</h3>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.introduction {
  display: flex;
  flex-direction: column;
  align-items: center;
  direction: rtl;
  padding: .8vw .8vw 4vw .8vw;
  background-color: #f0f2f5;
  box-sizing: border-box;
  position: relative;
}

.header {
  position: absolute;
  top: 1vw;
  right: 1vw;
}

.logo {
  height: 4vw;
}

.title {
  text-align: center;
  margin-top: 7vw;
}

.title h1 {
  font-size: 1.5vw;
  color: #007bff;
  margin-bottom: 1vw;
}

.title h2 {
  font-size: 1.3vw;
  color: #007bff;
  font-weight: bold;
}

.subtitle {
  text-align: center;
  margin-top: 1.5vw;
}

.subtitle h3 {
  font-size: 1vw !important;
  color: #343a40;
  border: .05vw solid #007bff;
  border-radius: .5vw;
  padding: 0.5vw 3vw;
}
</style>
